import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Routes from './config/Routes';
import { autoLogin } from './actions/Authentication';
import { isAuthenticated, getUser } from './selectors/Authentication';
import '@ant-design/compatible/assets/index.css';
import '../resources/less/antd-compatible-overrides.less';
import './App.less';
import { FooterContentForm, HtmlHeader, NavigationForm } from './components';
import { Layout } from 'antd';
import { Map } from 'immutable';
import { isSpecificUser } from '././utility/AuthorityUtils';

const { Header, Content, Footer } = Layout;

class App extends Component {
  /**
   * Attempts to auto login when application is loaded.
   */
  componentDidMount() {
    /* When application mounts attempt autologin */
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for(let registration of registrations) {
        registration.unregister();
      }
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        registration.unregister();
      });
      caches.keys().then(function(cacheNames) {
        cacheNames.forEach(function(cacheName) {
          caches.delete(cacheName);
        });
      });
    }

    this.props.autoLogin();
  }

  render() {
    return (
      <Layout className='layout layout-extra'>
        <HtmlHeader />
        <Header>
          <NavigationForm
            isAdmin={isSpecificUser(this.props.user, ['ADMIN', 'SUPERUSER', 'MOCK'])}
            isAuthenticated={this.props.isAuthenticated}
            user={this.props.user}
          />
        </Header>
        <Content className='content'>{Routes(this.props.isAuthenticated)}</Content>
        <Footer className={'footer'}>
          <FooterContentForm />
        </Footer>
      </Layout>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state
 * @returns {{isAuthenticated, user}}
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
    user: getUser(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch
 * @returns {{autoLogin: autoLogin}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      autoLogin: autoLogin,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{isAuthenticated: shim, autoLogin: shim, user: shim}}
 */
App.propTypes = {
  isAuthenticated: PropTypes.bool,
  autoLogin: PropTypes.func,
  user: PropTypes.instanceOf(Map),
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
